import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName',
  standalone: true,
})
export class FullNamePipe implements PipeTransform {
  transform(value: { firstName: string; lastName: string }): string {
    if (!value || !value.firstName || !value.lastName) {
      return '';
    }
    return `${value.firstName} ${value.lastName}`;
  }
}
